import {Component} from '@angular/core';
import {AlertController, IonicPage, ModalController, NavController, NavParams} from 'ionic-angular';
import {OrderService} from '../../services/OrderService';
import {Order} from '../../model/Order';
import {OrderRequest} from '../../model/OrderRequest';
import {OperationService} from '../../services/OperationService';
import {Operation, OperationCustomerPlanningSetting} from '../../model/Operation';
import {AuthService} from '../../services/AuthService';
import {Store, StoreActivityDay, StoreDashboard} from '../../model/Store';
import {OrderInfo} from '../nav/OrderInfo';
import {ActivityDate, DateService} from '../../services/DateService';
import {apiconfig} from '../../app/api.config';
import {DatePipe} from "@angular/common";
import {SelectedFile} from '../order-view/order-view';
import {Intervention, OrderEditForm, UIMissionPlanningDetails} from '../order-view/model/OrderEditForm';
import {MissionPlanningComplianceReport} from "../../model/MissionPlanningComplianceReport";
import {FTSector} from "../../model/FieldTeam";
import {StoreService} from "../../services/StoreService";
import {MyFilter} from "../store-dashboard/store-dashboard";
import {ResourcePlanningService} from "../../services/ResourcePlanningService";
import {OrderEditDwstModalPage} from "../order-edit-dwst-modal/order-edit-dwst-modal";
import {SlotsForStoreReportSlot} from "../../model/ReportingSlots";

/**
 * Generated class for the OrderEditPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@IonicPage()
@Component({
  selector: 'page-order-edit',
  templateUrl: 'order-edit.html',
})
export class OrderEditPage {

  public iconsURL: string = apiconfig.LOGA_ICONS;
  public apiConfig: any = apiconfig;

  order: Order;

  operation: Operation;
  customerPlanningSettings: OperationCustomerPlanningSetting;

  /**
   * sectors for which we can place an order
   */
  uiSectorsForOrder: FTSector[];
  store: Store;

  orderViewForm: OrderEditForm;

  //container to display errors on planning, if not compliant with operation details
  planningComplientReport: MissionPlanningComplianceReport;

  contactSharingToWorkerAllowed: boolean;

  myPickerOptions: any;


  /**
   * arraybuffer with content to upload when will be creating the order
   */
  private brief2upload: ArrayBuffer;
  private brief2uploadMetaDta = null;

  uiShowBriefMission: boolean;
  uiShowStoreCheckInInfo: boolean;
  uiShowCsDetails: boolean;


  storeDashboard: StoreDashboard;
  uiFilter: MyFilter = new MyFilter();


  constructor(private navCtrl: NavController,
              private navParams: NavParams,
              private orderService: OrderService,
              private operationService: OperationService,
              private storeService: StoreService,
              private authService: AuthService,
              private dateService: DateService,
              private alertCtrl: AlertController,
              private resourcePlanningService: ResourcePlanningService,
              private modalController: ModalController,
              private datePipe: DatePipe
  ) {
  }


  /**
   * Before show the page, we need to load order info, operation kits and operation profils
   *
   * WARNING we must keep it on IonViewDidLoad otherwise it will be triggered with day changes
   */
  ionViewDidLoad() {

    console.log('ionViewDidLoad for OrderEdit')

    this.myPickerOptions = {
      mode: "ios",
    };


    // read param from navigator
    let orderInfo: OrderInfo = this.navParams.data['orderInfo'];

    if (this.authService.getLoggedUser() != null)
      this.contactSharingToWorkerAllowed = this.authService.getLoggedUser().contactSharingToWorkerAllowed;


    const operationId = orderInfo.operation.id;

    this.operationService.loadOperation(operationId).toPromise()
      .then(operation => {
        this.operation = operation;
      }).then(op => {
      return this.operationService.loadOperationCustomerPlanningSettings(operationId).then((planningSetting: OperationCustomerPlanningSetting) => {
        this.customerPlanningSettings = planningSetting;

        //we need to init the values of the toogle method will fail to take the inverse of null
        this.uiShowBriefMission = true; // default is ON
        this.uiShowStoreCheckInInfo = false;
        this.uiShowCsDetails = false;
        return op;
      })
    }).then(op => {
      // existing order , find it to edit
      if (orderInfo && orderInfo.order) {
        this.contactSharingToWorkerAllowed = false;

        return this.orderService.loadOrder(orderInfo.order).then(order => {
          this.order = order;
          this.store = Store.fromStoreLocation(this.order.location);

          // prepare toggles
          this.reviewToggles();

          // init form with order data
          this.orderViewForm = new OrderEditForm(Store.fromStoreLocation(this.order.location), this.operation, this.order);

          this.checkDateValue()
            .then(a => this.finalizeLoading(operationId))
            .then(a => this.validate())
            .then(a => this.reviewMissionMultiObjectives());
        })
      } else {

        // not an existing order, we have to create it
        this.store = orderInfo.store;
        this.orderViewForm = new OrderEditForm(this.store, this.operation, undefined);

        // --- date and planning picker selection for new Orders ----

        if (orderInfo.dailyTourPlanning != null) {

          this.orderViewForm.dailyTourPlanning = orderInfo.dailyTourPlanning;

          // -- in tour mode, we don't want to display a lot of details for planning
          this.orderViewForm.nbDays = 1;
          this.orderViewForm.days = [1];
          this.orderViewForm.interventions[0].logaDate = orderInfo.tourPlanningDay;
          this.orderViewForm.interventions[0].uiDisplayDate = new ActivityDate().withTimeStamp(orderInfo.tourPlanningDay).computeShortLabel();
          if (orderInfo.previousOrderInTour != null && orderInfo.previousOrderInTour.activities != null && orderInfo.previousOrderInTour.activities.length > 0) {
            let act = orderInfo.previousOrderInTour.activities[0];
            let startOfAct = act.pmEndTime == null ? act.amEndTime : act.pmEndTime;
            this.orderViewForm.interventions[0].amStartTime = new Date(startOfAct.getTime() + 30 * 60 * 1000).toLocaleTimeString('fr-FR');
            this.orderViewForm.interventions[0].amDuration = 60;
          }

        } else if (orderInfo.defaultDate != null) {
          // -- if we come from another page, we might have a default date
          this.orderViewForm.nbDays = 1;
          this.orderViewForm.interventions[0].logaDate = orderInfo.defaultDate;
          this.orderViewForm.interventions[0].uiDisplayDate = new ActivityDate().withTimeStamp(orderInfo.defaultDate).computeShortLabel();
        }

        // select default when we have one profile and one kit
        if (this.operation.operationProfils)
          if (this.operation.operationProfils.length == 1)
            this.orderViewForm.profil = this.operation.operationProfils[0].id;

        if (this.operation.kits)
          if (this.operation.kits.length == 1)
            this.orderViewForm.kit = this.operation.kits[0].id;

        this.finalizeLoading(operationId).then(any => {
          if (orderInfo.duplicateFromOrder != null) {
            this.orderService.loadOrder(orderInfo.duplicateFromOrder).then(order => {
              this.orderViewForm = new OrderEditForm(Store.fromStoreLocation(order.location), this.operation, order);
              this.reviewToggles();
            });
          }
        });

        return op;
      }

    }).then(anyP => {
      // loading a field team with relevant sectors for this store, it will be used to feed the sectors selection popup to attach the right quota on back-end
      return this.orderService.loadCurrentFieldTeam(true, this.orderViewForm.store.id).then(ft => {
        this.uiSectorsForOrder = [];
        ft.findAreas().forEach(area => {
          if (area.sectors != null) {
            area.sectors.forEach(s => {
              this.uiSectorsForOrder.push(s);
            })
          }
        })
      });
    }).then(anyP => {
      // -- if we have a default date, we might to check already now if we are valid
      return new Promise<any>((res, reject) => {
        if (orderInfo.defaultDate != null || orderInfo.previousOrderInTour != null) {
          return this.checkDateValue();
        }
      });
    });
  }

  /**
   * internal common stuff to do to get the model ready
   * @param operationId
   */
  private finalizeLoading(operationId: number): Promise<any> {
    return this.operationService.findCustomerSector(operationId, this.store.id).then(customerSectorId => {
      this.orderViewForm.customerSectorId = customerSectorId;
    }).then(any => {
      this.orderViewForm.planificationSettings = this.customerPlanningSettings;
      // the form is not valid yet
      this.orderViewForm.valid = false;

      // prepare the Mission Planning purpose details zone
      let myuiMissionPlanningDetails = [];
      if (this.customerPlanningSettings.missionPlanningPurposes != null) {
        for (let mpp of this.customerPlanningSettings.missionPlanningPurposes) {
          let e = new UIMissionPlanningDetails();
          e.selected = false;
          e.details = "";
          e.name = mpp.name;
          e.purposeId = mpp.id;
          myuiMissionPlanningDetails.push(e);
        }
      }
      this.orderViewForm.uiMissionPlanningDetails = myuiMissionPlanningDetails;

      // set nb max days
      if (this.customerPlanningSettings.nbOfConsecutivePlannedDays != null && this.customerPlanningSettings.nbOfConsecutivePlannedDays > 0) {

        // set nb days max (user do not change this)
        this.orderViewForm.nbDays = this.customerPlanningSettings.nbOfConsecutivePlannedDays;

        // remove nb days we do not need : To not showed those number of days
        let nbDaysToRemove = this.orderViewForm.interventions.length - this.customerPlanningSettings.nbOfConsecutivePlannedDays;
        for (let c = 0; c < nbDaysToRemove; c++) {
          this.orderViewForm.interventions.pop();
          this.orderViewForm.days.pop();
        }
      }

      // set time fix for a day ?
      if (this.customerPlanningSettings.hasTimeFix()) {

        this.orderViewForm.interventions.forEach(inter => {
          let date: Date = new Date();
          date.setHours(this.customerPlanningSettings.amStartTime, 0, 0, 0);
          inter.amStartTime = this.datePipe.transform(date, "HH:mm");
          inter.amDuration = (this.customerPlanningSettings.amEndTime - this.customerPlanningSettings.amStartTime) * 60;

          date.setHours(this.customerPlanningSettings.pmStartTime, 0, 0, 0);
          inter.pmStartTime = this.datePipe.transform(date, "HH:mm");
          inter.pmDuration = (this.customerPlanningSettings.pmEndTime - this.customerPlanningSettings.pmStartTime) * 60;
        });
      }


      // prepare store dashboard & calendars
      this.uiFilter.storeId = this.orderViewForm.store == null || this.orderViewForm.store.id == null ? null : this.orderViewForm.store.id;
      this.uiFilter.year = new Date().getFullYear();
      this.uiFilter.month = new Date().getMonth();
      this.uiFilter.operationId = null;

      this.orderViewForm.uiFullyLoaded = true;

      this.refreshDatePicker();
    });
  }

  uiIsSavePending: boolean = false;

  /**
   * Form is validated, we can call API to change this order
   */
  onSave(event: any): Promise<any> {

    console.log("--- Starting save ---")

    if (this.orderViewForm.profil === undefined || this.orderViewForm.profil == null) {
      this.displayErrorMessage("Demande non complète", 'Merci de saisir un profil d\'intervention');
      return;
    }
    this.uiIsSavePending = true;

    let orderRequest: OrderRequest = new OrderRequest();
    orderRequest.setup(this.orderViewForm);

    // lets double confirm we can't set it if we can't check if this is allowed
    if (!this.contactSharingToWorkerAllowed)
      orderRequest.sharingCustomerSectorContactDetailsToWorker = false;


    /////
    // CHECK QUOTA
    let duration: number = 0;
    for (let i of this.orderViewForm.interventions)
      if (i.logaDate)
        duration += i.computeDuration();

    //we need the API to return something and not crash, but if there is no CS selected, then let's just return -1
    let csId = orderRequest.customerSector ? orderRequest.customerSector : -1;

    return this.operationService.loadHourlyQuotaStatus(csId, orderRequest.profil)
      .then((quota) => {

        if (this.order == null) {
          // -- check if current quota is enough, if it's not, then we can't proceed, if it's a modification, we will let the server have fun instead
          console.log('quota available : ' + quota.availableQuota + ", requested additional duration : " + duration);

          if (quota.availableQuota < (duration / 60)) {
            let msg = 'Votre demande ne peut être confirmée, faute de quota disponible.<br/><br/>';

            if (quota.availableQuota == null)
              msg += 'Il semble que les quota ne soient pas définis sur cette opération et/ou profil intervenant, veuillez contacter votre interlocuteur';
            else {
              if ("GLOBALOPERATION" === quota.availableQuotaType)
                msg += 'Votre quota disponible imputé sur le global de la campagne est de ' + Math.round((quota.availableQuota / 60) * 100) / 10 + ' heure(s), et vous chercher à planifier ' + Math.round((duration / 60) * 10) / 10 + ' heure(s).';
              else
                msg += 'Votre quota disponible est de ' + Math.round((quota.availableQuota / 60) * 100) / 10 + ' heure(s), et vous chercher à planifier ' + Math.round((duration / 60) * 10) / 10 + ' heure(s).';
            }
            this.displayErrorMessage("Quota dépassé", msg);
            return;
          }
        }


        let navCtr = this.navCtrl;

        if (this.order)
          return this.processMissionOrderUpdate(orderRequest).then(aa => {
            this.uiIsSavePending = false;
          });
        else
          return this.processPostNewRequest(orderRequest, navCtr).then(aa => {
            this.uiIsSavePending = false;
          });
      });

  }

  /**
   * internal method to process an update of mission
   * @param orderRequest
   */
  private processMissionOrderUpdate(orderRequest: OrderRequest) {
    return this.orderService.updateOrder(this.order.id, orderRequest)
      .then((response) => {

          console.log("Order update sucessful " + this.order.id)

          if (response.quotaExceed) {
            const r = Math.round((response.quota - response.currentQuota) * 10) / 10;
            this.displayErrorMessage('Quota non disponible', "Votre demande de modification n'a pu être prise en compte faute de quota disponible.");
            return;
          }

          if (this.brief2upload != null) {
            this.orderService.uploadClientBriefMission(this.order.id, this.brief2upload, {
              type: this.brief2uploadMetaDta.type,
              name: this.brief2uploadMetaDta.name
            }).then(a => {
              console.log(a);
            }).catch(err => {
              console.log("could not push attached file")
              console.log(err);
              this.displayErrorMessage("Erreur de transmission", "Le fichier de directive n'a pas été transmis à cause d'une erreur technique. Peut-être est-il trop volumineux?");
            })
          }

          let alert = this.alertCtrl.create({
            title: 'Validation',
            message: ' Vos modifications ont été prises en compte',
            buttons: [{
              text: 'Retour', role: 'back', handler: () => {
                this.navCtrl.pop();
              }
            }]
          });
          alert.present();
        }
      ).catch(err => {
        this.displayErrorMessage("Erreur de Transmission", ' Vos modifications n\'ont pas été prises en compte suite à une erreur technique, veuillez contacter le responsable opération.')
      });
  }

  /**
   * internal method dedicated to post a request for a new planning entry for a new Mission Order
   * @param orderRequest
   * @param navCtr
   */
  private processPostNewRequest(orderRequest: OrderRequest, navCtr: NavController): Promise<any> {

    //we double check the compliance of the request
    return this.orderService.checkPlanningCompliance(orderRequest).then(complianceReport => {

      this.planningComplientReport = complianceReport;
      this.validate();

      if (complianceReport.planningCompliance)
        return this.orderService.createOrder(orderRequest).then(createResponse => {
          // -- we want now to upload the attachment

          if (createResponse.quotaExceed) {
            const r = Math.round((createResponse.quota - createResponse.currentQuota) * 10) / 10;

            if (createResponse.quotaExcededDetails == null || createResponse.quotaExcededDetails.length < 1)
              this.displayErrorMessage('Quota non disponible', "Votre demande d'intervention n'a pu être prise en compte faute de quota disponible.<br/>Vous disposez à date d'un quota disponible de " + r + "heures.")
            else
              this.displayErrorMessage('Quota non disponible', "Votre demande d'intervention n'a pu être prise en compte faute de quota disponible.<br/><br/>" + createResponse.quotaExcededDetails)

            return false
          } else {

            if (this.brief2upload != null) {
              console.log('going to upload brief mission')
              this.orderService.uploadClientBriefMission(createResponse.missionOrder, this.brief2upload, {
                type: this.brief2uploadMetaDta.type,
                name: this.brief2uploadMetaDta.name
              }).then(a => {
                console.log(a);
              }).catch(err => {
                this.displayErrorMessage("Erreur de transmission", "Le fichier n'a pas été transmis à cause d'une erreur technique");
                console.log(err);
              })
            }

            let alert = this.alertCtrl.create({
              title: 'Validation',
              message: "Votre demande d'intervention est enregistrée",
              enableBackdropDismiss: false,
              buttons: [
                {
                  text: 'Retour',
                  role: 'back',
                  handler: () => {
                    navCtr.pop();
                  }
                }
              ]
            });
            alert.present();

            return true;
          }

        }).catch(err => {
          console.log(err);
          this.displayErrorMessage("Erreur d'enregistrement", "Votre demande de création n'a pu aboutir, veuillez contacter votre chef de projet");
        });

    });


  }

  /**
   * utility method to display an error message
   * @param title
   * @param message
   */
  private displayErrorMessage(title: string, message: string) {
    let alert = this.alertCtrl.create({
      title: title,
      message: message,
      buttons: ['Fermer'],
      cssClass: 'alertDanger'
    });
    alert.present();
  }

  /**
   *
   * @param id
   */
  onDeleteActivity(index: number) {

    if (this.customerPlanningSettings != null
      && this.customerPlanningSettings.nbOfConsecutivePlannedDays != null
      && this.customerPlanningSettings.nbOfConsecutivePlannedDays > 0) {

      let alert = this.alertCtrl.create({
        title: 'Confirmation',
        message: 'Êtes-vous sûr de vouloir supprimer cette journée d\'intervention ? (Les autres journée seront également supprimées.)',
        buttons: [
          {text: 'Annuler', role: 'cancel'},
          {
            text: 'Valider',
            handler: () => {
              for (const inter of this.orderViewForm.interventions)
                if (inter != null && inter.id != null)
                  this.orderService.deleteActivity(inter.id).then((response) => {
                    // empty each value for this intervention to new input
                    inter.clear();
                  });
            }
          }
        ]
      });
      alert.present();
    } else {

      let alert = this.alertCtrl.create({
        title: 'Confirmation',
        message: 'Êtes-vous sûr de vouloir supprimer cette journée d\'intervention ?',
        buttons: [
          {text: 'Annuler', role: 'cancel'},
          {
            text: 'Valider',
            handler: () => {
              // remove from array to refresh the view
              this.orderViewForm.nbDays = this.orderViewForm.nbDays - 1;
              this.orderService.deleteActivity(this.orderViewForm.interventions[index].id).then(n => {
                this.orderViewForm.interventions.splice(index, 1);
              });
            }
          }
        ]
      });
      alert.present();
    }


  }

  /**
   * will try to delete the mission
   * @param id
   */
  requestMissionDelete(id: number) {

    let alert = this.alertCtrl.create({
      title: 'Suppression de Mission',
      message: 'Êtes-vous sûr de vouloir supprimer cette commande ?',
      buttons: [
        {text: 'Annuler', role: 'cancel'},
        {
          text: 'Valider',
          handler: () => {
            this.orderService.deleteOrder(id).then(success => {
              this.navCtrl.pop();
            })
          }
        }
      ]
    });
    return alert.present();
  }


  hasNbDaysFix(): boolean {
    return this.customerPlanningSettings != null && this.customerPlanningSettings.nbOfConsecutivePlannedDays > 0;
  }


  /**
   * When start date we can check his value
   * It depends on Operation Planification Settings
   */
  checkDateValue(): Promise<any> {
    console.log('Check Date Value')
    let orderRequest: OrderRequest = new OrderRequest();
    orderRequest.setup(this.orderViewForm);

    return this.orderService.checkPlanningCompliance(orderRequest).then(complianceReport => {
      this.planningComplientReport = complianceReport;
      this.validate();
    });
  }


  /**
   * Evaluate if we can let the user hit the save button, or if there is a validation issue
   */
  validate() {
    if (this.orderViewForm != null) {

      this.orderViewForm.valid = false;
      this.orderViewForm.trimDays();

      if (this.planningComplientReport != null)
        this.orderViewForm.valid = this.planningComplientReport.planningCompliance;
      
      if (!this.customerPlanningSettings.useSlotPlanning) {
          const hasInvalid = this.orderViewForm.interventions.some(i => {
          if (i.logaDate == null) return;

          if (i.amStartTime == null && i.pmStartTime == null) {
            return true;
          } else if (i.amDuration == null && i.pmDuration == null) {
            return true;
          }

          return false;
        });

        this.orderViewForm.valid = !hasInvalid;
      }

    }
  }


  /**
   *
   * @param evt
   */
  briefingDocumentSelected(evt) {

    if (evt == null) {
      this.brief2uploadMetaDta = null;
      this.brief2upload = null;
    } else {

      const reader = new FileReader();

      reader.onloadend = () => {
        let ab: ArrayBuffer = reader.result;
        this.brief2upload = ab;
      };

      if (evt.target.files != null && evt.target.files.length > 0) {
        this.brief2uploadMetaDta = new SelectedFile();
        this.brief2uploadMetaDta.type = evt.target.files[0].type;
        this.brief2uploadMetaDta.name = evt.target.files[0].name;
        reader.readAsArrayBuffer(evt.target.files[0]);
      }
    }
  }

  isPendingValidation() {
    return true;
  }

  // -- date picker methods
  /**
   *
   */
  previousMonth() {
    this.uiFilter.previousMonth();
    this.refreshDatePicker();
  }

  /**
   *
   */
  nextMonth() {
    this.uiFilter.nextMonth();
    this.refreshDatePicker();
  }

  private refreshDatePicker() {
    this.storeDashboard = null;
    this.storeService.loadStoreDashboard(this.uiFilter.storeId, this.uiFilter.year, 1 + this.uiFilter.month, null).then(d => {

      this.uiFilter.dateLabel = new Date();
      this.uiFilter.dateLabel.setFullYear(this.uiFilter.year);
      this.uiFilter.dateLabel.setMonth(this.uiFilter.month, 1);

      this.storeDashboard = d;
    });
  }


  adActiveClass(ad: StoreActivityDay, opt: number) {
    return this.orderViewForm.interventions[opt].logaDate != null && this.orderViewForm.interventions[opt].logaDate == ad.logaDay ? "active" : "inactive";
  }

  /**
   * call back when a date is selected for one intervention
   * @param ad
   * @param opt
   */
  datePicked(ad: StoreActivityDay, opt: number) {
    this.orderViewForm.interventions[opt].logaDate = ad.logaDay;

    this.orderViewForm.interventions[opt].uiDisplayDate = new ActivityDate().withTimeStamp(ad.logaDay).computeShortLabel();
    this.orderViewForm.interventions.forEach(i => i.uiShowDataPicker = false);

    if (this.customerPlanningSettings.useSlotPlanning) {
      this.resourcePlanningService.loadSlotsForStoreAndOperation(ad.logaDay, this.orderViewForm.operation.id, this.orderViewForm.store.id).then(r => {
        this.orderViewForm.interventions[opt].planningSlots = r.slots;
      });

      this.orderViewForm.interventions[opt].uiSelectedSlot = null;
      this.orderViewForm.interventions[opt].uiSelectedSlotTemplate = null;
      this.orderViewForm.interventions[opt].planningSlotId = null;
    }

    this.checkDateValue();
  }


  displayMyDatePicker(optId: number) {
    if (this.orderViewForm != null && this.orderViewForm.interventions != null) {
      this.orderViewForm.interventions.forEach(i => i.uiShowDataPicker = false);
      this.orderViewForm.interventions[optId].uiShowDataPicker = true;
    }
  }

  // --- END Picker methods

  computeBgStyle(orderViewForm: OrderEditForm) {
    return {
      "background": "url('https://contact-loga2.agence-impact.com/resources/operation/" + orderViewForm.operation.id + "/banner') center repeat black",
      "background-size": "cover"
    };
  }

  computeBackUrl(opCard: Operation): any {
    return {
      "background": "url('https://contact-loga2.agence-impact.com/resources/operation/" + opCard.id + "/banner') center repeat black",
      "background-size": "cover",
      "width": "100%",
      "height": "64px"
    };
  }


  private reviewToggles() {
    if (this.order != null) {
      this.uiShowBriefMission = this.order.comment != null && this.order.comment.length > 0;
      this.uiShowStoreCheckInInfo = (this.order.storeContact != null && this.order.storeContact.length > 0) || (this.order.mobileStoreContact != null && this.order.mobileStoreContact.length > 0);
      //this.uiShowCsDetails = this.contactSharingToWorkerAllowed;
      this.uiShowCsDetails = this.order.appointment != null || this.order.appointmentTime != null;

    }
    // just because sometimes we need to refresh the status of Save button
    // this is really not a good hack, but just in case somebody is blocked in editing...
    this.validate();

  }


  private reviewMissionMultiObjectives() {
    console.log('toto')
    console.log(this.order)
    if (this.order != null && this.orderViewForm) {
      // -- review mission briefing toogles and content
      if (this.order.plannedPurposes != null) {
        for (let mpp of this.order.plannedPurposes) {
          for (let uiMpp of this.orderViewForm.uiMissionPlanningDetails) {
            if (uiMpp.purposeId == mpp.purposeId) {
              uiMpp.selected = true;
              uiMpp.details = mpp.instructions;
            }
          }
        }
      }
    }
  }

  pickSlotFromTemplate(slot: SlotsForStoreReportSlot, intervention: Intervention) {
    return this.resourcePlanningService.loadOperationPlanningTemplateOptions(this.orderViewForm.operation.id).then(o => {
      if (slot.assignedScheduleSlot != null) {
        o.templates.forEach(t => {
          if (t.slots != null) {
            t.slots.forEach(tpSlot => {
              if (tpSlot.id == slot.assignedScheduleSlot.id && tpSlot.slotIndex == slot.indexInDay) {
                intervention.planningSlotId = slot.id;
                intervention.dailyWorkerScheduleTemplateSlotId = tpSlot.id;
                intervention.uiSelectedSlot = slot;
                intervention.uiSelectedSlotTemplate = t;
              }
            })
          }
        });
        return this.checkDateValue();
      } else {

        const slots = [];
        if (o.templates != null)
          o.templates.forEach(t => {
            if (t.slots != null) {
              t.slots.forEach(sl => {
                if (sl.slotIndex == slot.indexInDay)
                  slots.push(sl);
              })
            }
          });

        const m = this.modalController.create(OrderEditDwstModalPage, {
          slots: slots,
          indexOfSlot: slot.indexInDay,
          slotDisplayName: slot.displayName
        });

        m.onDidDismiss(data => {
          if (data != null) {
            intervention.planningSlotId = slot.id;
            intervention.dailyWorkerScheduleTemplateSlotId = data.templateSlot.id;
            intervention.uiSelectedSlot = slot;

            o.templates.forEach(tpl => {
              if (data.templateSlot.template == tpl.id)
                intervention.uiSelectedSlotTemplate = tpl;
            })
          } else {
            intervention.planningSlotId = null;
            intervention.uiSelectedSlot = null;
            intervention.uiSelectedSlotTemplate = null;
            intervention.dailyWorkerScheduleTemplateSlotId = null;
          }

          return this.checkDateValue();
        });

        return m.present();
      }
    });
  }

  computeSlotClass(slot: SlotsForStoreReportSlot) {
    if (slot == null) return "";
    if (slot.activity == null && slot.assignedScheduleSlot != null)
      return "slot-constraint-item";
    else if (slot.activity != null)
      return "slot-busy-item"
    else if (!slot.openForPlanning)
      return "slot-closed-item";
    else
      return 'slot-free-item';
  }

  computeInstructionItemClass(mp: UIMissionPlanningDetails) {
    if (mp.selected)
      return "instruction-selected";
    else
      return "instruction-not-selected";
  }
}



// WEBPACK FOOTER //
// ./src/pages/order-edit/order-edit.ts